<ul class="list-unstyled rebate-values">
    <li *ngFor="let item of bonusBuckValues; let i = index" (click)="onValueClick(item)" [ngClass]="{'active': item.isActive}" >
        {{getbonusBucksDisplay(item)}}
    </li>
</ul>
<button mat-button matStepperNext id='next-btn' class="float-right" [disabled]="buttonDisabled">Next</button>